import React from 'react';
import { AppButton, Box, Inscription, Preloader } from '@common-fe/common-fe';

import { useSidebarStore } from '@/modules/core/components/Sidebar/store/useSidebarStore';
import theme from '@/styles/theme';

import { DEFAULT_PAGE } from './common';

interface Props {
  onCancel: () => void;
  hasValidationErrors: boolean;
  page: number;
  isLoading: boolean;
  setPage: (value: React.SetStateAction<number>) => void;
  onBack: () => void;
  totalPages?: number;
}

export const EditListFooter: React.FC<Props> = ({
  onCancel, hasValidationErrors, page, totalPages, isLoading, setPage, onBack,
}) => {
  const { pinned } = useSidebarStore();

  return (
    <Box
      width="100%"
      height={{ min: '88px' }}
      background="module"
      margin={{ top: 'spacing24' }}
      justify="center"
      style={{ position: 'fixed', bottom: 0, left: 0 }}
      pad={{ left: pinned ? '250px' : '50px' }}
    >
      <Box
        width={theme.defaultContentWidth}
        alignSelf="center"
        direction="row"
        justify="between"
        wrap
        pad={{ horizontal: 'spacing24' }}
      >
        <AppButton
          testId='cancel_button'
          buttonType="tertiary"
          onClick={onCancel}
        >
          Cancel
        </AppButton>
        <Box direction="row" align="center">
          {hasValidationErrors ? (
            <Inscription
              lineHeight="20px"
              color="danger"
              margin={{ right: '24px' }}
            >
              Please correct the highlighted errors
            </Inscription>
          ) : null}

          {page === DEFAULT_PAGE ? null : (
            <AppButton
              width="160px"
              buttonType="secondary"
              onClick={onBack}
              disabled={page === DEFAULT_PAGE}
            >
              Previous
            </AppButton>
          )}
          <AppButton
            testId="EditListFooter_next"
            width="160px"
            style={{ marginLeft: theme.spacings.spacing12 }}
            onClick={() => {
              if (totalPages && page < totalPages) {
                setPage(page + 1);
              }
            }}
            disabled={page === totalPages}
          >
            {isLoading ? <Preloader color="white" /> : `Next (${page}/${totalPages})`}
          </AppButton>
        </Box>
      </Box>
    </Box>
  );
};
